import { render, staticRenderFns } from "./Elemental.vue?vue&type=template&id=6a66d0cc&"
import script from "./Elemental.vue?vue&type=script&lang=js&"
export * from "./Elemental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports